module.exports = __webpack_public_path__ + "static/media/Plants.90a4d9ca.png";